/**
 * Todo valor monetário do motor é um inteiro em centavos.
 * Nada de float em conta de dinheiro: 0,1 + 0,2 não pode virar 0,30000000000000004.
 */

export type Centavos = number;

export function centavos(valor: number): Centavos {
  if (!Number.isInteger(valor)) {
    throw new Error(`Valor em centavos precisa ser inteiro, recebido: ${valor}`);
  }
  return valor;
}

/** Aplica um desconto percentual inteiro (ex.: 6) e arredonda para o centavo mais próximo. */
export function aplicarDesconto(valor: Centavos, percentual: number): Centavos {
  if (percentual < 0 || percentual > 100) {
    throw new Error(`Percentual de desconto inválido: ${percentual}`);
  }
  return Math.round((valor * (100 - percentual)) / 100);
}

/** Formata centavos como "R$ 2.012,79". */
export function formatarBRL(valor: Centavos): string {
  const negativo = valor < 0;
  const abs = Math.abs(valor);
  const reais = Math.floor(abs / 100);
  const cents = abs % 100;
  const milhar = String(reais).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${negativo ? '-' : ''}R$ ${milhar},${String(cents).padStart(2, '0')}`;
}

/** Divide o total em n parcelas que somam exatamente o total; os centavos que sobram vão para as primeiras. */
export function dividirEmParcelas(total: Centavos, n: number): Centavos[] {
  if (!Number.isInteger(n) || n < 1) throw new Error(`Número de parcelas inválido: ${n}`);
  const base = Math.floor(total / n);
  const resto = total - base * n;
  return Array.from({ length: n }, (_, i) => base + (i < resto ? 1 : 0));
}
